import axios from "axios";

const state = {
  currentUser: {},
}

const mutations = {
  setCurrentUser(state, payload) {
    state.currentUser = payload
  }
}

const actions = {
  fetchCurrentUser({ commit }) {
    axios.get('user/me')
    .then((response) => commit('setCurrentUser', response?.data || {}))
    .catch(() => commit('setCurrentUser', {}))
  }
}

export default {
  state,
  mutations,
  actions
}